export default __webpack_public_path__ + "assets/6a9edbd5457d3586993f5c7e5e06c0f0.jpg";